module.exports = __webpack_public_path__ + "img/pauli-z-root-dagger-3.51078999.svg";